import src from "IMAGE";
export default { src, width: 140, height: 100, blurWidth: 0, blurHeight: 0};
